import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../../components/Layout/Layout';
import api from '../../../api/axios';

export default function TrainingForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: '', description: '', passingScore: 80 });
  const [pdfFile, setPdfFile] = useState(null);
  const [currentPdf, setCurrentPdf] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isEdit) {
      api.get(`/trainings/${id}`).then(res => {
        const t = res.data;
        setForm({ title: t.title, description: t.description || '', passingScore: t.passing_score });
        setCurrentPdf(t.pdf_original_name || '');
      });
    }
  }, [id, isEdit]);

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const data = new FormData();
      data.append('title', form.title);
      data.append('description', form.description);
      data.append('passingScore', form.passingScore);
      if (pdfFile) data.append('pdf', pdfFile);

      if (isEdit) {
        await api.put(`/trainings/${id}`, data);
        navigate(`/admin/trainings/${id}`);
      } else {
        const res = await api.post('/trainings', data);
        navigate(`/admin/trainings/${res.data.id}`);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Fehler beim Speichern');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Layout title={isEdit ? 'Schulung bearbeiten' : 'Neue Schulung'}>
      <div style={{ maxWidth: 600 }}>
        <form onSubmit={handleSubmit} className="card">
          {error && <div className="alert alert-error">{error}</div>}

          <div className="form-group">
            <label>Titel *</label>
            <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required placeholder="z.B. Arbeitssicherheit 2024" />
          </div>

          <div className="form-group">
            <label>Beschreibung <span style={{ color: 'var(--gray-dark)', fontWeight: 400 }}>({form.description.length}/255)</span></label>
            <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value.slice(0, 255) })} placeholder="Kurze Beschreibung der Schulung..." rows={3} maxLength={255} />
          </div>

          <div className="form-group">
            <label>Bestehensgrenze (%)</label>
            <input type="number" min={1} max={100} value={form.passingScore}
              onChange={e => setForm({ ...form, passingScore: Number(e.target.value) })} required />
          </div>

          <div className="form-group">
            <label>PDF-Datei {isEdit ? '(leer lassen um beizubehalten)' : '*'}</label>
            {currentPdf && <p style={{ fontSize: '0.85rem', color: 'var(--gray-dark)', marginBottom: '0.5rem' }}>Aktuell: {currentPdf}</p>}
            <input type="file" accept=".pdf" onChange={e => setPdfFile(e.target.files[0])} required={!isEdit} />
          </div>

          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => navigate(isEdit ? `/admin/trainings/${id}` : '/admin/trainings')}>Abbrechen</button>
            <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
              {saving ? 'Speichern...' : isEdit ? 'Änderungen speichern' : 'Schulung erstellen'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
